<template>
    <div class="game-simple">
        <Draggable v-model="questions" handle=".handle" v-bind="dragOptions">
            <div v-for="(question, i) in questions" :key="i">
                <QuestionSimple
                    v-if="questionTypeSlugById[question.question_type_id] == 'mcq_ucq'"
                    class="my-5"
                    title="QCM/QCU"
                    :number="i"
                    :question="question"
                    :canAddQuestion="true"
                    :hasLabel="true"
                    :hasMedia="true"
                    :mediaLoaded="mediaLoaded"
                    @delete-question="deleteQuestion"
                    @update-question="updateQuestion"
                    @open-panel="openPanel(i)"
                />
                <QuestionSimple
                    v-else-if="questionTypeSlugById[question.question_type_id] == 'true_false'"
                    class="my-5"
                    title="Vrai/Faux"
                    :number="i"
                    :question="question"
                    :canAddQuestion="true"
                    :hasMedia="true"
                    :mediaLoaded="mediaLoaded"
                    @delete-question="deleteQuestion"
                    @update-question="updateQuestion"
                    :options="questionOptions.true_false"
                    @open-panel="openPanel(i)"
                />
            </div>
        </Draggable>

        <div class="flex justify-center items-center mt-6">
            <button
                class="plus rounded-lg h-10 px-4 flex justify-center items-center"
                @click="addQuestion('mcq_ucq')"
            >
                <span class="text-xl mr-1">+</span> QCM/QCU
            </button>

            <button
                class="plus rounded-lg h-10 px-4 flex justify-center items-center ml-4"
                @click="addQuestion('true_false')"
            >
                <span class="text-xl mr-1">+</span> Vrai/Faux
            </button>
        </div>

        <RightPanel ref="rightPanel" title="Choix de média">
            <Medias
                :selectOnly="true"
                :draggable-asset="true"
                :default-type-filter-slug="panelFilters"
                @media-loaded="mediaLoaded = true"
                @select-media="onMediaSelected"
            />
        </RightPanel>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import Draggable from 'vuedraggable'

import QuestionSimple from '@/components/Games/Question_simple'
import RightPanel from '@/components/RightPanel'
import Medias from '@/views/Medias'

export default {
    name: 'QuizSimple',
    components: {
        QuestionSimple,
        Draggable,
        RightPanel,
        Medias,
    },
    props: {
		game: {
			type: Object,
			required: true,
			default: null
		}
    },
    data(){
        return {
            mediaLoaded: false,
            panelQuestionIndex: null,
            panelFilters: [],
            questionOptions: {
                true_false: {
                    fixedAnswers: true,
                    hasMultipleAnswers: false,
                    editableAnswers: true,
                },
            }
        }
    },
    computed: {
        ...mapState("Games", {
            questionTypeSlugById(state){
                if (!state.question_type_list || Object.keys(state.question_type_list).length <= 0) return {}

                return state.question_type_list.reduce((dict, questionType) => {
                    dict[questionType.id] = questionType.slug
                    return dict
                }, {})
            },
            questionTypeIdBySlug(state){
                if (!state.question_type_list || Object.keys(state.question_type_list).length <= 0) return {}

                return state.question_type_list.reduce((dict, questionType) => {
                    dict[questionType.slug] = questionType.id
                    return dict
                }, {})
            }
        }),
        questions:{
            get() {
                if (!this.game)
                    return []
                return JSON.parse(JSON.stringify(this.game.questions));
            },
            set(value){
                this.$emit('update-all-questions', value)
            }
        },
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        },
    },
    methods:{
        addQuestion(typeSlug){
            const typeId = this.questionTypeIdBySlug[typeSlug]

            if (!typeId) {
                return
            }

            const answers = []

            switch (typeSlug) {
                case 'mcq_ucq':
                    answers.push({
                        text: '',
                        is_correct: false,
                    })
                    break

                case 'true_false':
                    answers.push({
                        text: "Vrai",
                        is_correct: true
                    })
                    answers.push({
                        text: "Faux",
                        is_correct: false
                    })
                    break
                
            }

            const question = {
                answers,
                text: '',
                correction: '',
                question_type_id: typeId,
            }

            this.$emit('add-questions', [question])
        },
        updateQuestion(i, data){
            this.$emit('update-question', i, data)
        },
        deleteQuestion(i){
            this.$emit('delete-questions', [i])
        },
        openPanel(questionIndex) {
            this.panelFilters = ['image']
            this.panelQuestionIndex = questionIndex
            this.$refs['rightPanel'].show()
        },
        hidePanel() {
            this.$refs['rightPanel'].hide()
        },
        onMediaSelected(asset) {
            if (isNaN(this.panelQuestionIndex) || this.panelQuestionIndex < 0)
                return

            if (asset?.type?.slug !== 'image') {
                return
            }

            this.updateQuestion(this.panelQuestionIndex, {
                media_id: asset.id
            })
            this.hidePanel()
        }
    }
}
</script>

<style lang="scss">

</style>